document.addEventListener("DOMContentLoaded", async function () {
  let loadingInterval;

  function startLoadingAnimation(element) {
    let dots = 0;
    loadingInterval = setInterval(() => {
      dots = (dots + 1) % 4;
      element.textContent = ".".repeat(dots || 1);
    }, 500);
  }

  function stopLoadingAnimation() {
    clearInterval(loadingInterval);
  }
  // Start loading animation immediately
  const pointsDiv = document.getElementById("points-balance");
  if (pointsDiv) {
    startLoadingAnimation(pointsDiv);
  }

  // Tab switching
  const tabButtons = document.querySelectorAll(".tab-button");
  const tabContents = document.querySelectorAll(".tab-content");

  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const tabName = button.dataset.tab;

      tabButtons.forEach((btn) => btn.classList.remove("active"));
      tabContents.forEach((content) => content.classList.remove("active"));

      button.classList.add("active");
      document.getElementById(`${tabName}-content`).classList.add("active");
    });
  });

  // Smile and JWT:
  async function initializeSmileUI(maxAttempts = 10, interval = 1000) {
    const customerInfoElement = document.getElementById("customerInfo");
    if (!customerInfoElement) throw new Error("Customer info not found");
    const customerId = customerInfoElement.dataset.customerId;
    if (!customerId) throw new Error("Customer ID not found");

    const response = await fetch(
      `https://sdftgwwat6.execute-api.us-east-2.amazonaws.com/prod?customerId=${customerId}`
    );
    const data = await response.json();
    if (!data.jwt) throw new Error("JWT not found in response");

    for (let attempts = 0; attempts < maxAttempts; attempts++) {
      if (typeof SmileUI !== "undefined") {
        SmileUI.init({
          channel_key: "channel_7waxZRg69h6H3ZdxGD5vL4A8",
          customer_identity_jwt: data.jwt,
        });
        return "SmileUI initialized successfully";
      }
      await new Promise((resolve) => setTimeout(resolve, interval));
    }
    throw new Error(`SmileUI not available after ${maxAttempts} attempts`);
  }

  try {
    await initializeSmileUI();
  } catch (error) {
    console.error("DEBUG: Failed to initialize SmileUI:", error);
  }

  async function fetchPointsProducts() {
    if (typeof Smile === "undefined") {
      await new Promise((resolve) => setTimeout(resolve, 500));
      return fetchPointsProducts();
    }

    const pointsProducts = await Smile.fetchAllPointsProducts();
    const discountContent = document.querySelector("#discount-content");
    const productContent = document.querySelector("#product-content");

    // Create a map of pointsProducts for easy lookup
    const pointsProductMap = new Map(
      pointsProducts.map((product) => [
        product.reward.name.toLowerCase(),
        product,
      ])
    );

    // Keep track of products we've already displayed
    const displayedProducts = new Set();

    // Iterate through discountButtonsData in the order defined in Liquid
    discountButtonsData.forEach((imageUrl, productName) => {
      const pointsProduct = pointsProductMap.get(productName.toLowerCase());
      if (pointsProduct) {
        const discountBtn = createDiscountButton(pointsProduct, imageUrl);
        const targetContent = pointsProduct.reward.name.endsWith("off coupon")
          ? discountContent
          : productContent;
        targetContent
          .querySelector(".flex-content-wrapper")
          .appendChild(discountBtn);
        displayedProducts.add(pointsProduct.id);
      }
    });

    // Display any remaining products that weren't in discountButtonsData
    pointsProducts.forEach((pointsProduct) => {
      if (!displayedProducts.has(pointsProduct.id)) {
        const discountBtn = createDiscountButton(pointsProduct);
        const targetContent = pointsProduct.reward.name.endsWith("off coupon")
          ? discountContent
          : productContent;
        targetContent
          .querySelector(".flex-content-wrapper")
          .appendChild(discountBtn);
      }
    });

    setupCustomerAndButtons();
  }

  function createDiscountButton(pointsProduct) {
    const discountBtn = document.createElement("button");
    discountBtn.className = "discount-btn content-block";
    discountBtn.dataset.pointsProductId = pointsProduct.id;
    discountBtn.dataset.title = pointsProduct.reward?.name;

    const couponAssets = document.getElementById("coupon-assets");
    const couponUrls = {
      5: couponAssets.dataset.coupon5,
      10: couponAssets.dataset.coupon10,
      15: couponAssets.dataset.coupon15,
      20: couponAssets.dataset.coupon20,
      50: couponAssets.dataset.coupon50,
      couponProduct: couponAssets.dataset.couponProduct,
    };
    const couponPopupUrls = {
      5: couponAssets.dataset.coupon5Popup,
      10: couponAssets.dataset.coupon10Popup,
      15: couponAssets.dataset.coupon15Popup,
      20: couponAssets.dataset.coupon20Popup,
      50: couponAssets.dataset.coupon50Popup,
      couponProduct: couponAssets.dataset.couponProductPopup,
    };

    function getCouponImg(discount) {
      const discountNumber = parseInt(discount, 10);
      if ([5, 10, 15, 20, 50].includes(discountNumber)) {
        return couponUrls[discountNumber];
      }
      return couponUrls.couponProduct;
    }
    function getCouponPopupImg(discount) {
      const discountNumber = parseInt(discount, 10);
      if ([5, 10, 15, 20, 50].includes(discountNumber)) {
        return couponPopupUrls[discountNumber];
      }
      return couponPopupUrls.couponProduct;
    }

    if (pointsProduct.reward?.name.endsWith("off coupon")) {
      const discountAmount = extractDiscountAmount(pointsProduct.reward.name);
      discountBtn.innerHTML = `
        <img src="${getCouponImg(discountAmount)}" 
        alt="${pointsProduct.reward.name} Coupon"
        width="258"
        height="311"
        class="normal-version"
        >
        <img src="${getCouponPopupImg(discountAmount)}" 
        alt="${pointsProduct.reward.name} Coupon"
        width="258"
        height="311"
        class="popup-version"
        >
        <div class="discount-bottom-absolute">
          <div class="discount-code-title">Discount code</div>
          <div class="discount-code-desc">${
            pointsProduct.reward.description
          }</div>
          <div class="discount-credits" style="margin-bottom: 16px;">${
            pointsProduct.points_price
          } Points</div>
          <div class="membership-banner-btn membership-banner-btn--outline membership-banner-btn--black"
          style="max-width: 148px; font-size: 14px; margin-top: 20px;"
          >Redeem Now</div>
        </div>
      `;
    } else {
      const productImageUrl = discountButtonsData.get(
        pointsProduct.reward?.name.toLowerCase()
      );
      discountBtn.innerHTML = `
        <img src="${getCouponImg("product")}" alt="${
        pointsProduct.reward?.name
      } Coupon"
        width="260"
        height="410"
        class="normal-version"
        >
        <img src="${getCouponPopupImg("product")}" alt="${
        pointsProduct.reward?.name
      } Coupon"
        width="260"
        height="410"
        class="popup-version"
        >
        ${
          productImageUrl
            ? `
          <img 
            src="${productImageUrl}" 
            alt="${pointsProduct.reward?.name} Product" 
            class="discount-btn__product-img"
            width="263"
            height="182"
            style="position: absolute; top: 0px; left: 0px; width: 100%; height: auto; object-fit: contain; aspect-ratio: 263 / 182;"
          >
          `
            : ""
        }
        <div class="discount-bottom-absolute">
          <div class="discount-code-title discount-code-title--product">
            ${pointsProduct.reward?.name}
          </div>
          <div class="discount-code-desc">${
            pointsProduct.reward.description
          }</div>
          <div class="discount-credits">${
            pointsProduct.points_price
          } Points</div>
          <div class="membership-banner-btn membership-banner-btn--outline membership-banner-btn--black"
          style="max-width: 148px; font-size: 14px; margin-top: 20px;"
          >Redeem Now</div>
        </div>
      `;
    }

    return discountBtn;
  }

  function extractDiscountAmount(couponString) {
    const match = couponString.match(/\$(\d+)/);
    return match ? match[1] : null;
  }

  // Set up userRef links immediately
  setupUserRefLinks();

  function clickToOpenLoginPopup(event) {
    event.preventDefault();
    showLoginPopup();
  }

  function setupUserRefLinks() {
    const userRefLinks = document.querySelectorAll(".user-ref-link");
    userRefLinks.forEach((userRefLink) => {
      userRefLink.style.cursor = "pointer";
      userRefLink.addEventListener("click", clickToOpenLoginPopup);
    });
  }

  async function setupCustomerAndButtons() {
    try {
      const customer = await Smile.fetchCustomer({ include: "vip_tier" });

      // VIP tiers
      const tierName = customer.vip_tier.name.toLowerCase();
      const vipTierElements = document.querySelectorAll("[data-vip-tier]");
      vipTierElements.forEach((element) => {
        if (element.dataset.vipTier == tierName) {
          const badge = element.querySelector(".vip-tier-badge");
          if (badge) badge.textContent = "Current status";
        }
      });

      // Referral link
      const userRefLinks = document.querySelectorAll(".user-ref-link");
      userRefLinks.forEach((userRefLink) => {
        userRefLink.style.cursor = "pointer";
        userRefLink.removeEventListener("click", clickToOpenLoginPopup);
        userRefLink.addEventListener("click", (event) => {
          event.preventDefault();
          navigator.clipboard.writeText(customer.referral_url);
          showCopySuccessPopup();
        });
      });

      // Points balance
      if (pointsDiv) {
        stopLoadingAnimation();
        pointsDiv.textContent = customer.points_balance;
      }

      // Discount buttons
      const discountButtons = document.querySelectorAll(".discount-btn");
      discountButtons.forEach((button) => {
        button.addEventListener("click", () => {
          const pointsProductId = button.dataset.pointsProductId;
          const title = button.dataset.title;
          showConfirmationPopup(title, pointsProductId, button);
        });
      });
    } catch (err) {
      // console.warn(
      //   "DEBUG: An error occurred while identifying the customer: " + err
      // );

      // If we can't identify the customer, we update both discount buttons and referral links
      // to show the login popup when clicked
      const discountButtons = document.querySelectorAll(".discount-btn");
      const userRefLinks = document.querySelectorAll(".user-ref-link");

      [...discountButtons, ...userRefLinks].forEach((element) => {
        element.addEventListener("click", (event) => {
          event.preventDefault();
          showLoginPopup();
        });
      });

      // Handle error state for points balance
      if (pointsDiv) {
        stopLoadingAnimation();
        pointsDiv.textContent = "Error loading points";
      }
    }
  }

  function showCopySuccessPopup() {
    const template = document.getElementById("copy-success-popup-template");
    const popup = template.content.cloneNode(true);

    const overlay = popup.querySelector(".membership-overlay");
    const popupElement = popup.querySelector(".membership-popup");

    document.body.appendChild(popup);

    const closePopup = () => {
      document.body.removeChild(overlay);
      document.body.removeChild(popupElement);
    };

    overlay.addEventListener("click", closePopup);

    const closeBtn = popupElement.querySelector(".popup-close-btn");
    if (closeBtn) closeBtn.addEventListener("click", closePopup);
  }

  function showLoginPopup() {
    const template = document.getElementById("login-popup-template");
    const popup = template.content.cloneNode(true);

    const overlay = popup.querySelector(".membership-overlay");
    const popupElement = popup.querySelector(".membership-popup");

    document.body.appendChild(popup);

    const closePopup = () => {
      document.body.removeChild(overlay);
      document.body.removeChild(popupElement);
    };

    overlay.addEventListener("click", closePopup);

    const closeBtn = popupElement.querySelector(".membership-popup-close-btn");
    if (closeBtn) closeBtn.addEventListener("click", closePopup);

    popupElement.querySelector("#loginBtn").addEventListener("click", () => {
      window.location.href = "/account/login?return_url=/pages/rewards";
    });
  }

  function showConfirmationPopup(title, pointsProductId, button) {
    const template = document.getElementById("confirmation-popup-template");
    const popup = template.content.cloneNode(true);

    // Create a copy of the clicked button
    const buttonCopy = button.cloneNode(true);
    buttonCopy.removeAttribute("id");
    buttonCopy.classList.remove("discount-btn");
    buttonCopy.classList.remove("content-block");
    buttonCopy.classList.add("discount-btn-display");

    // Remove any event listeners
    const newButtonCopy = buttonCopy.cloneNode(true);

    // Insert the button copy into the popup
    popup.querySelector(".discount-btn-copy").appendChild(newButtonCopy);

    const overlay = popup.querySelector(".membership-overlay");
    const popupElement = popup.querySelector(".membership-popup");

    // copy the text inside .discount-code-desc to .discount-btn-description
    const description = button.querySelector(".discount-code-desc");
    const descriptionCopy = description.innerText;
    popupElement.querySelector(".discount-btn-description").innerText =
      descriptionCopy;

    document.body.appendChild(popup);

    const closePopup = () => {
      document.body.removeChild(overlay);
      document.body.removeChild(popupElement);
    };

    overlay.addEventListener("click", closePopup);

    const closeBtn = popupElement.querySelector(".membership-popup-close-btn");
    if (closeBtn) closeBtn.addEventListener("click", closePopup);

    popupElement.querySelector("#confirmBtn").addEventListener("click", () => {
      Smile.purchasePointsProduct(pointsProductId).then((pointsPurchase) => {
        navigator.clipboard.writeText(pointsPurchase.reward_fulfillment.code);

        const codeInput = document.querySelector(".copy-code-container input");
        const copyButton = document.querySelector(
          ".copy-code-container .copy-button"
        );
        codeInput.value = pointsPurchase.reward_fulfillment.code;
        copyButton.addEventListener("click", () => {
          navigator.clipboard.writeText(pointsPurchase.reward_fulfillment.code);
          alert("Code copied to clipboard!");
        });

        popupElement.classList.add("membership-popup--success");
      });
    });
  }

  fetchPointsProducts();
});
